/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./VTab.css";

import * as React from "react";

import { VTabProps, VTabState } from "./VTab.types";

export default class VTab extends React.Component<VTabProps, VTabState> {

   private componentClassName: string;
   private header: React.ReactNode;

   constructor(props: VTabProps) {

      super(props);

      this.componentClassName = "tk-vtab" + (this.props.componentName ? `-${this.props.componentName}` : "");

      this.state = {
         selectedPageIndex: 0
      }

   }

   public render() {

      const tabs: React.ReactNode[] = [];

      this.props.tabs.forEach(
         (tab, index) => {

            const tabIndex = tab.disabled ? {} : { "tabIndex": 0 };

            tabs.push(
               <div
                  {...tabIndex}
                  key={tab.label}
                  data-selected={this.state.selectedPageIndex === index} data-disabled={tab.disabled}
                  onMouseDown={(e) => this.tabMouseDown(e, index)}
                  onKeyDown={(e) => this.onKeyDown(e, index)}
               >
                  {tab.label}
               </div>
            )
         }
      )

      const content = this.props.tabs[this.state.selectedPageIndex].content;

      return (

         <div className={this.componentClassName}>

            <div className="tabs">
               {tabs}
            </div>

            <div className="content">
               {content}
            </div>

         </div>

      )

   }

   private tabMouseDown(e: React.MouseEvent | React.KeyboardEvent, index: number) {

      e.preventDefault();
      e.stopPropagation();

      (e.target as HTMLElement).focus();

      if (this.state.selectedPageIndex === index) return;
      if (this.props.tabs[index].disabled) return;

      if (this.props.onBeforeTabSwitch) {

         const allow = this.props.onBeforeTabSwitch(this.state.selectedPageIndex, index);

         if (typeof allow === "boolean") {
            if (allow) {
               this.setState({ selectedPageIndex: index });
               ((e.target as HTMLElement).parentElement?.children.item(index) as HTMLElement).focus();
            } else {
               (e.target as HTMLElement).focus();
            }
         } else {
            allow.then(
               value => {
                  if (value) {
                     this.setState({ selectedPageIndex: index });
                     ((e.target as HTMLElement).parentElement?.children.item(index) as HTMLElement).focus();
                  } else {
                     (e.target as HTMLElement).focus();
                  }
               }
            )
         }

      } else {

         this.setState({ selectedPageIndex: index });
         (e.target as HTMLElement).focus();

      }

   }

   private onKeyDown = (e: React.KeyboardEvent, index: number) => {

      switch(e.key) {

         case "Enter":
         case " ":
            this.tabMouseDown(e, index);
            break;

         case "ArrowUp": {

            let els = Array.from((e.target as HTMLElement).parentElement!.children);
            let i = els.findIndex(el => el === e.target) - 1;

            if (this.walkDown(e, i)) return;

            i = els.length - 1;

            if (this.walkDown(e, i)) return;

            break;
         }

         case "ArrowDown": {

            let els = Array.from((e.target as HTMLElement).parentElement!.children);
            let i = els.findIndex(el => el === e.target) + 1;

            if (this.walkUp(e, i)) return;

            i = 0;

            if (this.walkUp(e, i)) return;

            break;
         }

      }

   }

   private walkDown = (e: React.KeyboardEvent, index: number): boolean => {

      let i = index;

      while(i >= 0) {
         const el = (e.target as HTMLElement).parentElement!.children.item(i);
         if (!el?.hasAttribute("data-disabled") || el.getAttribute("data-disabled") === "false") {
            this.tabMouseDown(e, i);
            (el as HTMLElement).focus();
            return true;
         }
         i--;
      }

      return false;

   }

   private walkUp = (e: React.KeyboardEvent, index: number): boolean => {

      let i = index;

      while(i < (e.target as HTMLElement).parentElement!.children.length) {
         const el = (e.target as HTMLElement).parentElement!.children.item(i);
         if (!el?.hasAttribute("data-disabled") || el.getAttribute("data-disabled") === "false") {
            this.tabMouseDown(e, i);
            (el as HTMLElement).focus();
            return true;
         }
         i++;
      }

      return false;

   }



}